/**
 * Constants for DUEL founding season recognition
 */

/**
 * End date of the founding season for DUEL
 * Users who joined before this date are considered founders
 */
export const FOUNDING_SEASON_END = '2026-06-30';

/**
 * Determines if a user is a founder based on their account creation date
 * @param createdAt - The user's account creation date (ISO string)
 * @returns true if the user joined during the founding season
 */
export function isFounder(createdAt: string): boolean {
  if (!createdAt) return false;
  
  const userJoinDate = new Date(createdAt);
  const foundingCutoff = new Date(FOUNDING_SEASON_END);
  
  return userJoinDate < foundingCutoff;
}